export const baseHeaderCardConfig = [
  {
    totalKey: "diagnosisTotal",
    recapturedKey: "diagnosisRecaptured",
    percentKey: "diagnosisRecapturedPercentage",
    footerTitle: "Recaptured",
  },
  {
    totalKey: "hccTotal",
    recapturedKey: "hccRecaptured",
    percentKey: "hccRecapturedPercentage",
    footerTitle: "Recaptured",
  },
  {
    totalKey: "diagnosisTotal",
    recapturedKey: "diagnosisNewlyCaptured",
    percentKey: "diagnosisNewlyCapturedPercentage",
    footerTitle: "New",
  },
  {
    totalKey: "hccTotal",
    recapturedKey: "hccNewlyCaptured",
    percentKey: "hccNewlyCapturedPercentage",
    footerTitle: "New",
  },
  {
    totalKey: "totalDiagnosisPatient",
    recapturedKey: "patientWithNoDiagnosis",
    percentKey: "patientWithNoDiagnosisPercentage",
    footerTitle: "Not Captured",
  },
  {
    totalKey: "totalHCCPatient",
    recapturedKey: "patientWithNoHCC",
    percentKey: "patientWithNoHCCPercentage",
    footerTitle: "Not Captured",
  },
  {
    totalKey: "totalPatientWithNoEncounter",
    recapturedKey: "patientsWithNoEncounter",
    percentKey: "patientsWithNoEncounterPercentage",
    footerTitle: "Not Encountered",
  },
];

export const headerTitlesByReport : any = {
  "HCC-GAP-REPORT": [
    ["Total Diagnosis Codes", "Recaptured in {year}"],
    ["Total HCC Categories", "Recaptured in {year}"],
    ["Total Diagnosis Codes", "Newly Captured in {year}"],
    ["Total HCC Categories", "Newly Captured in {year}"],
    ["Total Patients with Encounter", "Patient with No Diagnosis"],
    ["Total Patients with Encounter", "Patient with No HCC"],
    ["Total Patients", "Patients with No Encounters"],
  ],

  "HCC-PERIODICAL-GAP-REPORT": [
    ["Total Diagnosis Codes", "Recaptured Diagnosis Codes"],
    ["Total HCC Categories", "Recaptured HCC Categories"],
    ["Total Diagnosis Codes", "Newly Captured Diagnosis Codes"],
    ["Total HCC Categories", "Newly Captured HCC Categories"],
    ["Total Patients with Encounter", "Patient with No Diagnosis"],
    ["Total Patients with Encounter", "Patient with No HCC"],
    ["Total Patients", "Patients with No Encounters"],
  ],
};